import QuizService from 'src/modules/quiz/quizService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'QUIZ_FORM';

const quizFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await QuizService.find(id);
      }

      dispatch({
        type: quizFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizFormActions.INIT_ERROR,
      });

      getHistory().push('/quiz');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: quizFormActions.CREATE_STARTED,
      });

      const record = await QuizService.create(
        values,
      );

      dispatch({
        type: quizFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.quiz.create.success'),
      );

      getHistory().push(`/quiz/${record.id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: quizFormActions.UPDATE_STARTED,
      });

      await QuizService.update(id, values);

      dispatch({
        type: quizFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.quiz.update.success'),
      );

      getHistory().push(`/quiz/${id}`);
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: quizFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default quizFormActions;
